module.exports = __webpack_public_path__ + "static/img/11.597716e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/11.png
// module id = 54ZL
// module chunks = 0